import './_styles.scss';
import React from "react";
import { Item } from 'components';
import AirBed from 'assets/air_bed.png';

export default ({ caption, data=[] }) => {

  const Placeholder = Array.from(Array(5), (a,i)=>`${i}`);

  return (
    <section className='Section-Items'>
      <div className="Section-Wrapper">

        <div className="Section-Caption">
          {caption}
        </div>

        { (!!data.empty()) && Placeholder.map((a,i) => <Item key={i} loading/>)}

        { data.map((a,i) =>
            <Item
              id={a.handle}
              title={a.title}
              key={i.toString()}
              category={a.category}
              price={a.pricing.price}
              image={a.images[0] || AirBed}
              brand={a.vendor.toUpperCase()}

            />
          )
        }

      </div>
    </section>
  );
}
